{
  "focus.interruption.deleteAction": "Delete interruption record",
  "focus.interruption.deleteTitle": "Permanently delete this interruption?",
  "focus.interruption.deleteDescription": "The time and note for this interruption will be removed from the focus history.",
  "focus.interruption.deleteConfirm": "Delete permanently",
  "focus.interruption.deleteError": "The interruption could not be deleted."
}
